exports = module.exports = require("../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[class$=-terms-component]{font-family:Assistant,sans-serif;font-size:14px;padding:0 6px}[class$=-terms-component] h2{font-size:18px;text-align:center;padding:12px 0}[class$=-terms-component] h3,[class$=-terms-component] p{padding:6px 0}[class$=-terms-component] b{font-weight:700}[class$=-terms-component] ul li{padding:6px 0}[class$=-terms-component] .underline{text-decoration:underline}", ""]);

// exports
